export interface IArticle {
  title: string;
  type: EHeaderType;
  body: string;
  draft: boolean;
  outdated: boolean;
}

export enum EHeaderType {
  header1 = 'header1',
  header2 = 'header2',
  header3 = 'header3',
}

export enum ELegalsViews {
  SelectCountry = 'SelectCountry',
  Articles = 'articles',
}

export enum EArticleAlias {
  termsofuse = 'tou',
  privacypolicy = 'dataprivacy',
  imprint = 'imprint',
}

export type Continent = 'europe' | 'oceania' | 'asia' | 'africa' | 'america';

export interface Country {
  id: string;
  name: string;
  continent: Continent;
}

export type CountriesMap = {
  [id: string]: Country[];
};

export interface IArticlesResponsePayload {
  articles: IArticle[];
}
